import { openApi } from '@/api/request'

export default {
  getHomePage ({ userName, cruiseId }) {
    return openApi.get("/Rccl.OpenApi/HomePage/GetHomePage", {
      params: { userName, cruiseId }
    })
  },
  GetHomePagePost ({ userName, cruiseId }) {
    return openApi.post("/Rccl.OpenApi/HomePage/GetHomePagePost",{ userName, cruiseId })
  },
  getEmergencyMessage (requestData) {
    return openApi.post('/Rccl.OpenApi/EmergencyMessage/GetEmergencyMessage', requestData)
  },
  getSeo (url) {
    return openApi.get("/HomeApi/GetSeo", {
      params: {
        url
      }
    })
  },
  getNavItems () {
    return openApi.get("/Rccl.OpenApi/HomePage/GetNav")
  },
  GetNavPost () {
    return openApi.post("/Rccl.OpenApi/HomePage/GetNavPost")
  },
  getPageContent (url) {
    return openApi.get("/Rccl.OpenApi/PageContent/GetPageByUrl", {
      params: {
        url
      }
    })
  },
  getCallingCode () {
    return openApi.get('/Rccl.OpenApi/sendSms/getCallingCode')
  },
  getCountries () {
    return openApi.get('/Rccl.OpenApi/page/getNationality')
  },
  getPinyin (data) {
    return openApi.post('/Rccl.OpenApi/pinyin', {
      data
    })
  },
  getWechatSignature () {
    return openApi.get('/Rccl.OpenApi/PageContent/GetSignature', {
      params: {
        url: window.location.href.split('#')[0],
        v: (new Date()).getTime()
      }
    })
  },
  getTopFaq () {
    return openApi.get('/Rccl.OpenApi/PageContent/GetTopFaqHP')
  },
  getFaq (data) {
    data.v = (new Date()).getTime()
    return openApi.get('/Rccl.OpenApi/FAQ/Index', {
      params: data
    })
  },
  getFaqById (data) {
    return openApi.post('/Rccl.OpenApi/FAQ/GetById', data)
  },
  submitFaqFeedback (data) {
    return openApi.post('/Rccl.OpenApi/Faq/SubmitSuggestion', data)
  },
  cancelFaqFeedback (data) {
    return openApi.post('/Rccl.OpenApi/Faq/CancelSuggestion', data)
  },
  getShipDetail (shipCode) {
    return openApi.get('/Rccl.OpenApi/Ship/Display', {
      params: {
        shipCode
      }
    })
  },
  getShipExperience () {
    return openApi.get('/Rccl.OpenApi/Ship/Experience', {
      params: {
        v: (new Date()).getTime()
      }
    })
  },
  getContract () {
    return openApi.get('/Rccl.OpenApi/PageContent/GetPageContent')
  },
  getPrivacy () {
    return openApi.get('/Rccl.OpenApi/PageContent/GetPrivacy')
  },
  getRewardRule () {
    return openApi.get('/Rccl.OpenApi/PageContent/GetRewardRule')
  },
  getRecruitmentIndex () {
    return openApi.get('/Rccl.OpenApi/Recruitment/Home')
  },
  getRecruitmentSearch (cityName) {
    return openApi.get('/Rccl.OpenApi/Recruitment/Search', {
      params: {
        cityName,
        v: (new Date()).getTime()
      }
    })
  },
  getRecruitmentDetail (positionId) {
    return openApi.get('/Rccl.OpenApi/Recruitment/Detail', {
      params: {
        positionId,
        v: (new Date()).getTime()
      }
    })
  },
  getNews ({ offset, limit, NewsType }) {
    return openApi.get('/Rccl.OpenApi/RcclNews/GetNews', {
      params: {
        offset,
        limit,
        NewsType
      }
    })
  },
  getNewsTitle (newsId) {
    return openApi.get('/Rccl.OpenApi/RcclNews/GetNewsDetail',{
      params: {
        newsId
      }
    })
  },
  getNewsDetail (Id) {
    return openApi.get(`/Rccl.OpenApi/RcclNews/Detail/${Id}`)
  },
  getCountryList () {
    return openApi.get('/Rccl.OpenApi/Country/CountryList')
  },
  getCityDetail (cityName) {
    return openApi.get('/Rccl.OpenApi/ShorexIntro/ShorexIntroList',{
      params: {
        cityName
      }
    })
  },
  goLink (requestData) {
    const url = '/Rccl.OpenApi/HomePage/GoLink'
    return openApi.get(url, {
        params: requestData,
        v: (new Date()).getTime()
    })
  },
  // partnerLead(data) {
  //   return openApi.post('/Rccl.OpenApi/PartnerLead/CreateV2', data, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data'
  //     }
  //   })
  // },
  partnerLead(data) {
    return openApi.post('/Rccl.OpenApi/PartnerLead/CreateV3', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  getUDeskUrl(data) {
    return openApi.post('/Rccl.OpenApi/Udesk/GetWebIMUrl', data);
  }
}

